import { useMemo } from 'react';

import { PaymentStatus } from 'constants/payment';
import { useIsMobile } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { isDateInPastTenMinutes } from 'utils';
import { CheckSuccess } from 'views/components/base/check-success';
import { PaymentBox } from 'views/components/base/payment-box';
import { PaymentError } from 'views/components/base/payment-error';
import { BaseCard } from 'views/components/base/ui';

import { CompanyInfo } from '../company-info';
import { PaymentSuccess } from '../payment-success';

const PaymentContainer = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { isMobile } = useIsMobile();
  const isPastTenMinutes = useMemo(() => {
    if (paymentData) {
      const { status, isDemo, acsData, date } = paymentData;

      if (status === PaymentStatus.PAYMENT_SUCCESS || status === PaymentStatus.HOLDED) {
        return isDemo && Boolean(acsData) ? false : isDateInPastTenMinutes(date);
      }
    }

    return false;
  }, [paymentData]);

  const renderView = () => {
    switch (paymentData?.status) {
      case PaymentStatus.WAIT_PAYMENT:
        return <PaymentBox />;
      case PaymentStatus.PAYMENT_SUCCESS:
      case PaymentStatus.WAIT_PROCESSING:
      case PaymentStatus.HOLDED:
        return <PaymentSuccess />;
      case PaymentStatus.INTERNAL_ERROR:
      case PaymentStatus.PAYMENT_FAILED:
        return <PaymentError />;
      default:
        return null;
    }
  };

  return isPastTenMinutes ? (
    <CheckSuccess />
  ) : (
    <BaseCard>
      {(!isMobile || paymentData?.status === PaymentStatus.WAIT_PAYMENT) && <CompanyInfo />}
      {renderView()}
    </BaseCard>
  );
};

export { PaymentContainer };
